// Spodná mobilná navigácia — slovenské dvojče locale/cs/bottomNav.js.
export default {
  nav: 'Hlavná navigácia',
  home: 'Domov',
  cats: 'Kategórie',
  orders: 'Objednávky',
  account: 'Účet',
  cart: 'Košík',
  chat: 'Chat',
};
